import React, { Component } from 'react';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';

import { typhoonBusTimelineData } from '../stores/typhoonBusTimelineData'

export default class TableExampleComplex extends Component {
  state = {
    fixedHeader: true,
    stripedRows: false,
    showRowHover: false,
    selectable: true,
    multiSelectable: false,
    enableSelectAll: false,
    deselectOnClickaway: true,
    showCheckboxes: false,
    // height: '300px',
  };

  handleToggle = (event, toggled) => {
    this.setState({
      [event.target.name]: toggled,
    });
  };

  render() {
    return (
      <div>
        <Table
          height={this.state.height}
          fixedHeader={this.state.fixedHeader}
          fixedFooter={this.state.fixedFooter}
          selectable={this.state.selectable}
          multiSelectable={this.state.multiSelectable}
        >
          <TableHeader
            displaySelectAll={this.state.showCheckboxes}
            adjustForCheckbox={this.state.showCheckboxes}
            enableSelectAll={this.state.enableSelectAll}
          >
            <TableRow>
              <TableHeaderColumn tooltip="">颱風天(週一到週五)<br/>關渡站</TableHeaderColumn>
              <TableHeaderColumn tooltip=""><br/>和信</TableHeaderColumn>
              <TableHeaderColumn tooltip="">颱風天(週六半日)<br/>關渡站</TableHeaderColumn>
              <TableHeaderColumn tooltip=""><br/>和信</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            displayRowCheckbox={this.state.showCheckboxes}
            deselectOnClickaway={this.state.deselectOnClickaway}
            showRowHover={this.state.showRowHover}
            stripedRows={this.state.stripedRows}
          >
             {typhoonBusTimelineData.map( (row, index) => (
              <TableRow key={index} >
                <TableRowColumn style={{overflow:'unset'}}>{row.mon_guan}</TableRowColumn>
                <TableRowColumn style={{overflow:'unset'}}>{row.mon_kfs}</TableRowColumn>
                <TableRowColumn style={{overflow:'unset'}}>{row.aft_guan}</TableRowColumn>
                <TableRowColumn style={{overflow:'unset'}}>{row.aft_kfs}</TableRowColumn>
              </TableRow>
              ))} 
          </TableBody>
        </Table>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/typhoonBusTable.js